import { useState } from 'react';

/** Par de colores por hash del id (docs/08 §2): h = (h * 31 + charCode) >>> 0, h % 6. */
export function avatarIndex(id: string): number {
  let h = 0;
  for (const char of id) h = (h * 31 + char.charCodeAt(0)) >>> 0;
  return (h % 6) + 1;
}

/** Iniciales de las dos primeras palabras. */
export function initials(name: string): string {
  return name
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((word) => word.charAt(0).toUpperCase())
    .join('');
}

/**
 * Iniciales sobre el color del id o, si el paciente tiene, su foto (RF-PAC-14, FB-27). Si la foto
 * no carga (sin permiso, quitada en otra pantalla), vuelven las iniciales.
 */
export function Avatar({
  id,
  name,
  photoUrl,
}: {
  id: string;
  name: string;
  photoUrl?: string | null | undefined;
}) {
  const n = avatarIndex(id);
  const [broken, setBroken] = useState<string | null>(null);
  const photo = photoUrl != null && photoUrl !== broken ? photoUrl : null;
  return (
    <span
      className="avatar"
      aria-hidden="true"
      style={{ background: `var(--avatar-${String(n)}-bg)`, color: `var(--avatar-${String(n)}-fg)` }}
    >
      {photo === null ? (
        initials(name)
      ) : (
        <img
          src={photo}
          alt=""
          decoding="async"
          onError={() => {
            setBroken(photo);
          }}
        />
      )}
    </span>
  );
}
